import { BrowserUtil, RouterUtil, WeappUtil } from 'kuaidong-lib'
import { FileTypeEnum } from 'kuaidong-model'
import VueRouter, { RouteConfig } from 'vue-router'
const Index = () => import('../views/intelligent-classroom/Index.vue')
const ClassProcess = () => import('../views/intelligent-classroom/ClassProcessPage.vue')
const ClassProcessing = () => import('../views/intelligent-classroom/ClassProcessingPage.vue')

const StageClassEdit = () => import('../views/intelligent-classroom/StageClassEditPage.vue')
const ClassAppoint = () => import('../views/intelligent-classroom/ClassAppointPage.vue')
const ClassHistory = () => import('../views/intelligent-classroom/ClassHistoryListPage.vue')
const BatchAddStu = () => import('../views/intelligent-classroom/AddStuPage.vue')
const DelStuPage = () => import('../views/intelligent-classroom/DelStuPage.vue')
const UploadPage = () => import('../views/intelligent-classroom/UploadPage.vue')

const MapToolsPage = () => import('../views/intelligent-classroom/MapTools.vue')

const indexRoute: RouteConfig = {
  path: '/intelligent-classroom-teacher-home',
  name: 'intelligent_classroom_teacher_home',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智慧课堂',
  },
}

const stageClassEditRoute: RouteConfig = {
  path: '/intelligent-classroom-stage-class-edit',
  name: 'intelligent_classroom_stage_class_edit',
  component: StageClassEdit,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智慧课堂',
  },
}

const classAppointRoute: RouteConfig = {
  path: '/intelligent-classroom-teacher-class-appoint',
  name: 'intelligent_classroom_teacher_class_appoint',
  component: ClassAppoint,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智慧课堂',
  },
}

const classProcessRoute: RouteConfig = {
  path: '/intelligent-classroom-teacher-class-process',
  name: 'intelligent_classroom_teacher_class_process',
  component: ClassProcess,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智慧课堂',
  },
}

const classProcessingRoute: RouteConfig = {
  path: '/intelligent-classroom-processing',
  name: 'intelligent_classroom_processing',
  component: ClassProcessing,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智慧课堂',
  },
}

const classHistoryRoute: RouteConfig = {
  path: '/intelligent-classroom-teacher-class-history',
  name: 'intelligent_classroom_teacher_class_history',
  component: ClassHistory,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智慧课堂',
  },
}

const addStuRoute: RouteConfig = {
  path: '/intelligent-classroom-batch-add-stu',
  name: 'intelligent_classroom_batch_add_stu',
  component: BatchAddStu,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智慧课堂',
  },
}

const delStuRoute: RouteConfig = {
  path: '/intelligent-classroom-batch-del-stu',
  name: 'intelligent_classroom_batch_del_stu',
  component: DelStuPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智慧课堂',
  },
}

const uploadRoute: RouteConfig = {
  path: '/intelligent-classroom-stu-namelist-upload',
  name: 'intelligent_classroom_stu_namelist_upload',
  component: UploadPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智慧课堂上传学生名单',
  },
}

const MapToolsRoute: RouteConfig = {
  path: '/intelligent-classroom-map-tools',
  name: 'intelligent_classroom_map_tools',
  component: MapToolsPage,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '地图工具',
    ignoreLogin: true,
  },
}

export async function navigateToStuNamelistUploadMapping(
  router: VueRouter,
  params: {
    id: string
    url: string
    clazz: string
    grade: string
    onlyIdentifiers?: boolean
    fromWeapp?: boolean
    scene?: string
  }
) {
  const { id, url, onlyIdentifiers = false, clazz, grade, fromWeapp = false, scene = '' } = params
  if (BrowserUtil.isWeapp()) {
    // 智慧课堂学生名单上传
    WeappUtil.selectMessageFile({
      fileType: FileTypeEnum.Excel,
      target: RouterUtil.buildUrlFromRoute(addStuRoute, { id, url, clazz, grade }, router),
      isRedirect: fromWeapp,
      scene,
      id,
    })
  } else {
    router.replace({ name: addStuRoute.name, query: { clazz, grade } })
  }
}

export function redirectToStuNamelistUploadMapping(
  router: VueRouter,
  params: {
    id: string
    url: string
    clazz: string
    grade: string
    onlyIdentifiers?: boolean
    fromWeapp?: boolean
    scene?: string
  }
) {
  console.log('redirectToExamRecordUploadMapping', params)
  const { id, url, onlyIdentifiers = false, clazz, grade, fromWeapp = false, scene = '' } = params
  if (BrowserUtil.isWeapp()) {
    // 智慧课堂学生名单上传
    if (scene == 'intelligent_classroom_stu_namelist_upload') {
      WeappUtil.selectMessageFile({
        fileType: FileTypeEnum.Excel,
        target: RouterUtil.buildUrlFromRoute(addStuRoute, { id, url, clazz, grade }, router),
        isRedirect: fromWeapp,
        scene,
        id,
      })
    }
    router.go(-1)
  } else {
    router.replace({ name: uploadRoute.name, query: { id, url, onlyIdentifiers: onlyIdentifiers ? '1' : '0' } })
  }
}

export default [
  indexRoute,
  classProcessRoute,
  classAppointRoute,
  classHistoryRoute,
  addStuRoute,
  delStuRoute,
  uploadRoute,
  stageClassEditRoute,
  classProcessingRoute,
  MapToolsRoute,
]
